/**
 * Adjusts the position of an overlay element to ensure it stays within viewport bounds
 * @param eleClassName - CSS selector for the overlay element
 * @param options - Configuration options for the adjustment
 * @returns void
 */
export const adjustOverlayPosition = (
  eleClassName: string,
  options: {
    bottomPadding?: number;
    rightPadding?: number;
    shouldAdjustHorizontally?: boolean;
  } = {},
) => {
  const {
    bottomPadding = 46,
    rightPadding = 60,
    shouldAdjustHorizontally = false,
  } = options;

  // Get DOM elements
  const overlay = document.querySelector(eleClassName) as HTMLElement;
  if (!overlay) return;

  // Reset any existing transform to get true position
  overlay.style.transform = '';

  // Get measurements after resetting transform
  const overlayRect = overlay.getBoundingClientRect();
  const windowHeight = window.innerHeight;
  const windowWidth = window.innerWidth;

  // Only adjust if overlay extends beyond viewport
  if (
    overlayRect.bottom <= windowHeight - bottomPadding &&
    (!shouldAdjustHorizontally || overlayRect.right <= windowWidth)
  ) {
    return;
  }

  // Calculate adjustments
  const baseAdjustment = overlayRect.bottom - windowHeight + bottomPadding;
  const rightAdjustment = shouldAdjustHorizontally
    ? overlayRect.right - windowWidth + rightPadding
    : 0;

  // Build transform value based on required adjustments
  const transforms: string[] = [];

  if (baseAdjustment > 0) {
    transforms.push(`translateY(-${baseAdjustment}px)`);
  }
  if (shouldAdjustHorizontally && rightAdjustment > 0) {
    transforms.push(`translateX(-${rightAdjustment}px)`);
  }

  // Apply combined transforms if any adjustments are needed
  if (transforms.length > 0) {
    overlay.style.transform = transforms.join(' ');
    console.debug('overlay', (overlay.style.transform = transforms.join(' ')));
    // eslint-disable-next-line consistent-return
    return true;
  }
};
